import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons.min.js";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import { API_URL, API_URL_LOCAL } from "..";
import { useMapbox } from "../GoogleMapsContext";

// Mapbox token is assumed to be set in GoogleMapsContext

const LocationsPage = () => {
  const { mapboxgl } = useMapbox();
  const tableRef = useRef(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch company locations
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) {
          throw new Error("User not found in localStorage");
        }
        const response = await fetch(`${API_URL_LOCAL}/api/company/fetch/${user.id}`, {
          method: "GET",
        });
        if (!response.ok) throw new Error("Failed to fetch locations");
        const data = await response.json();
        setLocations(data.companies || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  // Initialize DataTable and render maps
  useEffect(() => {
    if (!locations.length || !tableRef.current) return;

    const table = $(tableRef.current).DataTable({
      data: locations,
      columns: [
        {
          title: "Location Information",
          data: null,
          render: (data) => `
            <div>
              <strong>Title:</strong> ${data.title}<br />
              <strong>Location:</strong> ${data.location}<br />
              <strong>Created At:</strong> ${new Date(data.created_at).toLocaleString()}<br />
              <strong>Geofence:</strong> ${data.geofence_status ? `Enabled (${data.geofence} meters)` : "Disabled"}<br />
              <strong>Employee Count:</strong> ${data.employeeCount}
            </div>
          `,
        },
        {
          title: "Map View",
          data: null,
          render: (data, type, row, meta) => `
            <div id="map-${meta.row}" style="height: 200px; width: 100%; border-radius: 8px;"></div>
          `,
          orderable: false,
        },
      ],
      responsive: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      destroy: true,
      drawCallback: () => {
        // Initialize Mapbox maps after DataTable draw
        locations.forEach((location, index) => {
          const mapContainer = document.getElementById(`map-${index}`);
          if (!mapContainer || mapContainer.classList.contains("map-initialized")) return;

          const [latitude, longitude] = location.location_map.split(",").map(Number);
          if (isNaN(latitude) || isNaN(longitude)) return;

          const map = new mapboxgl.Map({
            container: `map-${index}`,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [longitude, latitude],
            zoom: 14,
            interactive: false, // Disable interactions for simplicity
          });

          // Add marker
          new mapboxgl.Marker().setLngLat([longitude, latitude]).addTo(map);

          // Add geofence circle if enabled
          if (location.geofence_status && location.geofence) {
            const radius = parseFloat(location.geofence);
            if (!isNaN(radius)) {
              map.on("load", () => {
                map.addSource("geofence", {
                  type: "geojson",
                  data: {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: [longitude, latitude],
                    },
                  },
                });

                map.addLayer({
                  id: "geofence-circle",
                  type: "circle",
                  source: "geofence",
                  paint: {
                    "circle-radius": {
                      stops: [
                        [0, 0],
                        [20, radius],
                      ],
                      base: 2,
                    },
                    "circle-color": "#007bff",
                    "circle-opacity": 0.3,
                    "circle-stroke-color": "#007bff",
                    "circle-stroke-width": 2,
                  },
                });
              });
            }
          }

          mapContainer.classList.add("map-initialized");
        });
      },
    });

    // Cleanup DataTable on component unmount
    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [locations, mapboxgl]);

  return (
    <MasterLayout>
      <Breadcrumb title="Locations" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="d-flex justify-content-end mb-20">
            <Link to="/locations/add-location">
              <button className="btn btn-primary border border-primary-600 text-md px-24 py-8 radius-8">
                Add Location
              </button>
            </Link>
          </div>
          {loading && <div className="text-center">Loading...</div>}
          {error && (
            <div className="alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-20 fw-semibold text-lg radius-8">
              {error}
            </div>
          )}
          {!loading && !error && (
            <div className="table-responsive">
              <table ref={tableRef} className="table table-striped table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Location Information</th>
                    <th>Map View</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </MasterLayout>
  );
};

export default LocationsPage;